import { getSymmetricKey } from "../dataEncryption";
import { readFileJwtAsReadable } from "../dwclient/dwstorage";
import { loadJwt } from "../dwclient/localstorage/jwtStorage";
import { splitPath } from "../paths";
import { makeNodeAbsolutePath, makeZipPath } from "./zipdownloadworkerutil";
export const chromeDownload = async (provider, fileList, node, onDownloadProgress, signal) => {
    if (!window.showDirectoryPicker) {
        return;
    }
    if (provider === null) {
        return;
    }
    const authToken = await loadJwt();
    if (authToken === null) {
        return;
    }
    const key = getSymmetricKey(provider);
    if (key === null) {
        return;
    }
    const nodeAbsolutePath = makeNodeAbsolutePath(node, fileList);
    let totalFilesBytes = fileList.map((f) => f.size).reduce((acc, curr) => acc + curr, 0);
    const start = Date.now();
    let loadedFilesBytes = 0;
    let totalFiles = fileList.length;
    let loadedFiles = 0;
    const mainDirectoryHandle = await window.showDirectoryPicker({ mode: "readwrite" });
    signal?.throwIfAborted();
    /*const permission = await mainDirectoryHandle.requestPermission({ mode: "readwrite" });
    if (permission !== "granted") {
      throw new Error("Write permission was not granted.");
    }*/
    const errorFilePathList = [];
    for (const file of fileList) {
        signal?.throwIfAborted();
        let zipPath;
        let retry = 0;
        do {
            try {
                zipPath = sanitizeFileName(makeZipPath(file.path, nodeAbsolutePath));
                const fileName = splitPath(zipPath)?.name;
                if (fileName === undefined) {
                    continue;
                }
                const readable = await readFileJwtAsReadable(
                //const readable = await readFileInChunksAsReadableStream(
                provider, authToken, file.path, file.size, {
                    fileId: zipPath,
                    status: "downloading",
                    loadedFiles,
                    totalFiles,
                    loadedFilesBytes,
                    totalFilesBytes,
                    size: file.size,
                }, onDownloadProgress, signal);
                // save this file: file.path, zipPath, authToken, key, file.size);
                const directoryHandle = await getDirectoryHandleByZipPath(mainDirectoryHandle, zipPath);
                const fileHandle = await directoryHandle.getFileHandle(fileName, { create: true });
                const writable = await fileHandle.createWritable();
                await readable.pipeTo(writable, { signal });
                loadedFilesBytes += file.size;
                loadedFiles++;
                sendExtraDownloadProgress(onDownloadProgress, zipPath ?? "", start, loadedFiles, totalFiles, loadedFilesBytes, totalFilesBytes);
                console.log("File written", zipPath);
            }
            catch (error) {
                if (signal?.aborted) {
                    throw signal.reason ?? Object.assign(new Error("canceled"), { name: "AbortError" });
                }
                console.log("Error", file.path, "to", zipPath, error);
                if (error instanceof DOMException && (error.name === "SecurityError" || error.name === "AbortError")) {
                    throw error;
                }
                else if (error instanceof DOMException && error.name === "NetworkError") {
                    //console.log("Network error. Retrying");
                    retry = retry ? retry + 1 : 1;
                    if (retry < 3) {
                        //console.log("Waiting 5 secs");
                        await new Promise((resolve) => setTimeout(resolve, 5000));
                        //console.log("Wait finished");
                    }
                    else {
                        loadedFilesBytes += file.size;
                        loadedFiles++;
                        sendExtraDownloadProgress(onDownloadProgress, zipPath ?? "", start, loadedFiles, totalFiles, loadedFilesBytes, totalFilesBytes);
                    }
                }
                else {
                    // including if (error instanceof TypeError)
                    errorFilePathList.push(file.path);
                    totalFiles--;
                    totalFilesBytes -= file.size;
                    sendExtraDownloadProgress(onDownloadProgress, zipPath ?? "", start, loadedFiles, totalFiles, loadedFilesBytes, totalFilesBytes);
                }
            }
            /*if (retry > 0 && retry < 3) {
              console.log("retrying");
            }*/
        } while (retry > 0 && retry < 3);
        /*if (retry >= 3) {
          console.log("aborting retry");
        }*/
        retry = 0;
    }
    return errorFilePathList;
};
function sendExtraDownloadProgress(onDownloadProgress, zipPath, start, loadedFiles, totalFiles, loadedFilesBytes, totalFilesBytes) {
    if (onDownloadProgress) {
        onDownloadProgress({
            fileId: zipPath,
            status: "downloading",
            loaded: 0,
            total: 0,
            estimated: calculateEstimated(start, loadedFilesBytes, totalFilesBytes),
            loadedFiles,
            totalFiles,
            loadedFilesBytes,
            totalFilesBytes,
        });
    }
}
function calculateEstimated(startTimestamp, loadedBytes, totalBytes) {
    const currentTimestamp = Date.now();
    const elapsedMillis = currentTimestamp - startTimestamp;
    const rate = elapsedMillis / loadedBytes;
    return (rate * (totalBytes - loadedBytes)) / 1000.0;
}
async function getDirectoryHandleByZipPath(mainDirectoryHandle, zipPath) {
    const zipPathParts = splitPath(zipPath);
    if (zipPathParts === undefined || zipPathParts.parts === undefined) {
        return mainDirectoryHandle;
    }
    zipPathParts.parts.pop();
    let directoryHandle = mainDirectoryHandle;
    for (const part of zipPathParts.parts) {
        directoryHandle = await directoryHandle.getDirectoryHandle(part, { create: true });
    }
    return directoryHandle;
}
function sanitizeFileName(fileName) {
    return fileName.replace(/[:]/g, "-").replace(/[~]/g, "_").trim(); // Replace colons with dashes
}
